import { FormCrud } from "components/Form/hooks"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { reset } from "redux-form"
import { CreateGradeHooks } from ".."

const CreateUserData = () => {
    const formName = "createGrade"
    const dispatch = useDispatch()
    const setAlert = CreateGradeHooks.useAlert()
    const { actionSubmit } = FormCrud()

    const cancelAction = useCallback(() => {
        dispatch(reset(formName))
        setAlert(false)
    }, [])

    const submitBtns = [
        {
            id: 0,
            label: "הוספה",
            color: "secondary",
            action: () => actionSubmit(formName)
        },
        {
            id: 1,
            label: "ביטול",
            color: "light",
            action: () => cancelAction(formName)
        }
    ]


    return submitBtns

}

export default CreateUserData